<template>
    <div>
        <p v-if="getChangedStore1 && (ltype=='1')">{{readFromStore()}}</p>
        <p v-if="getChangedStore2 && (ltype=='2')">{{readFromStore()}}</p>
        <p v-if="getRefresh1 && (ltype=='1')">{{refreshData()}}</p>
        <p v-if="getRefresh2 && (ltype=='2')">{{refreshData()}}</p>
        
        <div>
            <v-toolbar dense @click="$store.commit('changeCollapse',0)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Assignment ({{mycontent.content.length}} chars)</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.a">
                <v-flex xs12 >
                    <quill-editor v-model="mycontent.content" :options="getEditorOption()">
                    </quill-editor>
                </v-flex>
                <v-flex xs12 justify-end>
                    <v-btn @click="showHtmlC">Show HTML</v-btn>
                    <v-btn v-if="showedHtmlC" @click="updateC">Update</v-btn>
                </v-flex>
                <v-textarea v-if="showedHtmlC" v-model="HtmlContent">
                </v-textarea>
            </div>

            <v-toolbar dense @click="$store.commit('changeCollapse',1)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Lines to reorder ({{mycontent.code.length}} chars)</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.b">

                <v-flex xs12>
                    <quill-editor v-model='mycontent.code' :options="getEditorOption2()">
                    </quill-editor>
                </v-flex>
                <v-flex xs12 justify-end>
                    <v-btn @click="showHtmlCD">Show HTML</v-btn>
                    <v-btn v-if="showedHtmlCD" @click="updateCD">Update</v-btn>
                </v-flex>
                <v-textarea v-if="showedHtmlCD" v-model=HtmlCode>
                </v-textarea>

                
                <v-card>
                    <v-card-title>Data to reorder: <v-btn @click="getLines()">Analyse</v-btn></v-card-title>
                    <v-card-text v-if="lines.length > 0">
                        <div v-for="(fd,index) in lines" :key="index">
                            <v-chip>{{fd}}</v-chip>
                        </div>
                    </v-card-text>
                </v-card>
                
            </div>
            
            <v-toolbar dense @click="$store.commit('changeCollapse',2)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Help</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.c">
                <v-flex xs12>
                    <quill-editor v-model="mycontent.help" :options="getEditorOption()">
                    </quill-editor>
                </v-flex>
                <v-flex xs12 justify-end>
                    <v-btn @click="showHtmlH">Show HTML</v-btn>
                    <v-btn v-if="showedHtmlH" @click="updateH">Update</v-btn>
                </v-flex>
                <v-textarea v-if="showedHtmlH" v-model=HtmlHelp>
                </v-textarea>
            
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
//import 'highlight.js/styles/routeros.css'
//import hljs from 'highlight.js'

export default {
    data() {
        return {
                showedHtmlC : false,
                showedHtmlCD : false,
                showedHtmlH : false,
                mycontent:  {
                    content: 'loading...',
                    code: 'loading...',
                    help: 'loading...'
                },
                HtmlContent: '',
                HtmlCode: '',
                HtmlHelp: '',
                lines: []            
              }
    },
    props: ['ltype'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getRefresh1',
                            'getRefresh2',
                            'getChangedStore1',
                            'getChangedStore2',
                            'getContent567',
                            'getCollapses',
                            'getFakes'
                        ])
    ,
    components: {
        quillEditor
    },
    methods: {
        showHtmlC() {
            this.showedHtmlC = !this.showedHtmlC
            this.HtmlContent = this.mycontent.content
        },
        showHtmlCD() {
            this.showedHtmlCD = !this.showedHtmlCD
            this.HtmlCode = this.mycontent.code
        },
        showHtmlH() {
            this.showedHtmlH = !this.showedHtmlH
            this.HtmlHelp = this.mycontent.help
        },
        updateC() {
            this.mycontent.content = this.HtmlContent
        },
        updateCD() {
            this.mycontent.code = this.HtmlCode
        },
        updateH() {
            this.mycontent.help = this.HtmlHelp
        },
        getLines() {
            this.lines = []
            var result = this.mycontent.code
            let answers = this.lines
            let str = ' class="ql-syntax" spellcheck="false"'
            while (result.indexOf(str)> -1) {
              result = result.substring(0, result.indexOf(str)) + result.substring(result.indexOf(str) + str.length)
            }
            var start = 0
            var end = 0
            var codes = []
            while (result.indexOf('<pre>')> -1) {
                start = result.indexOf('<pre>')
                end = result.indexOf('</pre>')
                codes.push(result.substring(start + 5, end))
                result = result.substring(0,start) + result.substring(end+6)
            }
         
            result.replace(/<p>(.*?)<\/p>/g, function(match, g1) { 
                answers.push(g1)
            })
            for(let i = 0; i<codes.length; i++) {
                result = codes[i]
                while (result.indexOf('\n')> -1) {
                    var index = result.indexOf('\n')
                    answers.push(result.substring(0, index))
                    result = result.substring(index+1)
                }
                if (result.length>0) answers.push(result)
            }
        },

        /************************************************************ */
        saveActualContent(mylang) {   
            var data = {
                lang_id : mylang.id,
                content: this.mycontent
            }
            this.$store.commit('setContent567', data)            
        },

        refreshData() {
           // var lang = null
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimaryTmp) {
                    this.saveActualContent(this.getLanguagePrimaryTmp)
                }
                this.$store.commit('setChangedStore1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondaryTmp)
                    this.saveActualContent(this.getLanguageSecondaryTmp)
                this.$store.commit('setChangedStore2',true)            
            }            
        },
        getContent567fromStore(lang_id) {
            return this.getContent567(lang_id)
        },

        readFromStore() {
            var con = -1
            if (this.ltype == 1) {
                this.$store.commit('setChangedStore1',false)
                con = this.getContent567fromStore(this.getLanguagePrimary.id)
                this.mycontent = con
            }
            if (this.ltype == 2) {                
                this.$store.commit('setChangedStore2',false)
                con = this.getContent567fromStore(this.getLanguageSecondary.id)
                this.mycontent = con
            }
        },
        getEditorOption() {
          return {
                modules: {
                    'toolbar': [
                    [{ 'header': '1' }, { 'header': '2' }],
                    [ 'bold', 'italic', 'underline', 'strike' ],
                    ['code-block','blockquote',  { 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    [ 'link', 'image', 'formula' ],
                    [ 'clean' ]
                    ],
     /*               syntax: {
                        highlight: text => hljs.highlightAuto(text).value
                    },
       */             imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            }
        },
        getEditorOption2() {
          return {
                modules: {
                    'toolbar': [
                    [ 'bold', 'italic', 'underline', 'strike' ],
                    ['code-block', { 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [ 'image', 'formula' ],
                    [ 'clean' ]
                    ],
                    imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            }
        }
    } 

}
</script>


<style>

</style>


